import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentProductPricesProps<T> = {
  enabled?: boolean;
  filters?: {
    search?: string;
    page?: number;
    productCategoryId?: string;
    branchId?: string;
  };
  mapper?: (data: any) => T,
};

export const useEstablishmentProductPrices = <T,>({
  enabled = true,
  filters: { search = '', page, productCategoryId, branchId } = {},
  mapper = Mapper.default<T>(),
}: UseEstablishmentProductPricesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta} = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    enabled,
    queryKey: ['establishmentProductPrices', search, page, productCategoryId, branchId],
    queryFn: () => {
      return privateAxios.get('/establishment/product_prices', {
        params: {
          search,
          page,
          'q[product_category_id_eq]': productCategoryId,
          'q[branch_id_eq]': branchId,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending,  ...rest };
};
